var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-hour"},[_c('div',{staticClass:"card-hour__text"},[_vm._v(_vm._s(_vm.formattedTime)+" hrs")]),_c('i',{staticClass:"card-hour__check material-icons"},[_vm._v("check")])])}
var staticRenderFns = []

export { render, staticRenderFns }